// extracted by mini-css-extract-plugin
module.exports = {"footerText":"UserSessionForm-module__footerText___3WUX8"};